/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Text, Box } from '@tishman/components';

import { CreditCardDisplayNames } from '../../../services/viva/constants';
import { selectRefund, useAppSelector } from '../../../store';

const textStyle = { lineHeight: 'body', fontSize: 5 };

export const RefundInfo = () => {
  const refund = useAppSelector(selectRefund);

  if (!refund) return null;

  return (
    <Box sx={{ mt: 5 }}>
      <Text sx={{ marginBottom: 3 }} variant="rockCenterPageName">
        Contact Billing
      </Text>
      <Text sx={textStyle} variant="largeP">
        {refund.name}
      </Text>
      <Text sx={textStyle} variant="largeP">
        {`${CreditCardDisplayNames[refund.creditCard.type]}  ****${
          refund.creditCard.suffix
        }`}
      </Text>
      <Text sx={textStyle} variant="largeP">
        Reason: {refund.reason}
      </Text>
    </Box>
  );
};
